import React from 'react'
import {Checkbox, Stack, TableCell, Typography} from "@mui/material"
import {useProductSettingsContext} from "../context/ProductSettingsContext";
import { SalesGeographyInMarketDatePicker } from "./SalesGeographyInMarketDatePicker";
import { SalesGeographyEndInMarketDatePicker } from "./SalesGeographyEndInMarketDatePicker";
import PropTypes from 'prop-types';
import { SETTINGS_GRID_CELL_PADDING, SETTINGS_GRID_SPANNED_COLUMN_COUNT } from '../../../Utilities/settingsGridColumns';

const enableInMarketDate = process.env.REACT_APP_ENABLE_IN_MARKET_DATE === 'true';
const enableSeasonalForecast = process.env.REACT_APP_ENABLE_SEASONAL_FORECAST === 'true';

export const DistrictRow = ({ row }) => {
    const {onRowSelectClick, isRowSelected, isRowCheckboxIndeterminate} = useProductSettingsContext();

    return (<React.Fragment>
        <TableCell sx={{ padding: SETTINGS_GRID_CELL_PADDING }} colSpan={SETTINGS_GRID_SPANNED_COLUMN_COUNT} className="District">
            <Stack direction='row' alignItems='center'>
                <Checkbox
                    id={row.id}
                    color="primary"
                    indeterminate={isRowCheckboxIndeterminate(row)}
                    checked={isRowSelected(row)}
                    onChange={event => onRowSelectClick(row, event.target.checked)}/>
                <Typography
                    sx={{ marginLeft: '48px' }}>{row.id}</Typography>
            </Stack>
        </TableCell>
        {enableInMarketDate && <SalesGeographyInMarketDatePicker row={row} className="District" />}
        {enableInMarketDate && enableSeasonalForecast && <SalesGeographyEndInMarketDatePicker row={row} className="District" />}
    </React.Fragment>)
}

DistrictRow.propTypes = {
    row: PropTypes.object,
}
